import {ROLES} from '../constants/roles';

const AUDIENCE_FOR_ROLE = {
    [ROLES.SUPER_ADMIN]: 'school-admin',
    [ROLES.SCHOOL_ADMIN]: 'school-admin',
    [ROLES.SENIOR_MEMBER_OF_STAFF]: 'senior-staff',
    [ROLES.MEMBER_OF_STAFF]: 'staff',
    [ROLES.EMPLOYEE]: 'employee',
    [ROLES.PARENT]: 'parent',
    [ROLES.STUDENT]: 'student'
};

const AUDIENCE_RANK = [
    'school-admin',
    'senior-staff',
    'staff',
    'employee',
    'parent',
    'student'
];

export const audiencesForRoles = roles => {
    const found = new Set();

    (roles ?? []).forEach(role => {
        const audience = AUDIENCE_FOR_ROLE[role];

        if (audience) {
            found.add(audience);
        }
    });

    return AUDIENCE_RANK.filter(audience => found.has(audience));
};
